<template>
    <div>
        <div
            v-for="(option, index) in options"
            :key="`option${index}`"
            class="preferences-propver__content"
        >
            <h3>
                {{ option.label }}
            </h3>
            <p>
                {{ $t(`Search.propver.Preferences.algorithm.${option.key}`) }}
            </p>
        </div>
    </div>
</template>

<script>
import i18n from '../../locales/i18n';

export default {
    name: 'AlgorithmPopover',
    i18n,
    props: {
        options: {
            type: Array,
            require: true,
            default: () => [],
        },
    },
};
</script>
